export default ({ $axios, app }, inject) => {
    inject('getDataFromCache', (url, addAuthHeader = true) => {
        return $axios
            .post(`${process.env.APP_URL}/data/fetch`, {
                url,
            });
    });
};
